import * as PropTypes from "prop-types";
import * as React from "react";

import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";

import Document from "src/models/document";

import SyntaxHighlighter from "react-syntax-highlighter";
// @ts-ignore
import { monokaiSublime } from "react-syntax-highlighter/dist/esm/styles/hljs/index";

const styles = (theme: Theme) => ({
  previewBlock: {
    height: "100%",
    objectFit: "contain",
    textAlign: "left",
    width: "100%"
  }
});

export interface IProps extends WithStyles<any> {
  doc: Document;
}

class Body extends React.Component<IProps, any> {
  public render() {
    const { classes } = this.props;

    if (this.props.doc.Data.preview && this.props.doc.Type === "image") {
      return (
        <img
          className={classes.previewBlock}
          src={"data:image/png;base64, " + this.props.doc.Data.preview}
        />
      );
    }

    if (this.props.doc.Data.body && this.props.doc.Type === "code") {
      return (
        <SyntaxHighlighter
          className={classes.previewBlock}
          style={monokaiSublime}
          language={this.getDocumentLanguageFromExt()}
          showLineNumbers={true}
        >
          {this.props.doc.Data.body}
        </SyntaxHighlighter>
      );
    }
    return null;
  }

  private getDocumentLanguageFromExt(): string {
    switch (this.props.doc.Data.extension) {
      case "go":
        return "go";
      case "js":
      case "jsx":
        return "javascript";
      case "py":
        return "python";
      default:
        return "text";
    }
  }
}

(Body as React.ComponentClass<IProps>).propTypes = {
  classes: PropTypes.object.isRequired
} as any;

// @ts-ignore
export default withStyles(styles)(Body);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Body.tsx